var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEditIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.1031 3.01253C16.4226 2.68664 16.8035 2.42732 17.2239 2.24954C17.6442 2.07176 18.0956 1.97906 18.552 1.97679C19.0083 1.97452 19.4606 2.06273 19.8827 2.23632C20.3048 2.40991 20.6883 2.66543 21.011 2.98813C21.3337 3.31082 21.5893 3.69428 21.7629 4.11634C21.9366 4.5384 22.0248 4.99069 22.0226 5.44706C22.0204 5.90344 21.9277 6.35485 21.75 6.77519C21.5722 7.19554 21.313 7.5765 20.9871 7.89603L19.8851 9.00003L15.0001 4.11503L16.1031 3.01253ZM14.1166 5.00003L4.01911 15.0985C3.63805 15.4793 3.36655 15.9556 3.23311 16.4775L2.01961 21.22C1.99283 21.3251 1.99384 21.4353 2.02254 21.5398C2.05124 21.6444 2.10664 21.7397 2.1833 21.8163C2.25996 21.893 2.35525 21.9484 2.45979 21.9771C2.56434 22.0058 2.67455 22.0068 2.77961 21.98L7.52311 20.768C8.04536 20.6348 8.52207 20.3632 8.90311 19.982L19.0006 9.88303L14.1166 5.00003Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/edit_icon.6f562e0d8acb85b41e7ef78cf892f417.svg";
export { ForwardRef as ReactComponent };